<template>
  <div class="m3u-generator">
    <h2>M3U Link Generator DomaciTV</h2>

    <!-- izbor servera -->
    <div class="input-container">
      <label for="server">Server:</label>
      <select v-model="selectedServer" id="server">
        <option v-for="server in servers" :key="server" :value="server">
          {{ server }}
        </option>
      </select>
    </div>

    <!-- username -->
    <div class="input-container">
      <label for="username">Username:</label>
      <input
        type="text"
        id="username"
        v-model="username"
        placeholder="Unesi username"
      />
    </div>

    <!-- password -->
    <div class="input-container">
      <label for="password">Password:</label>
      <input
        type="text"
        id="password"
        v-model="password"
        placeholder="Unesi password"
      />
    </div>

    <!-- generisani link -->
    <div class="result">
      <label>Generisani M3U Link:</label>
      <input type="text" :value="generatedLink" readonly />
      <button @click="copyLink">Kopiraj</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "M3ULinkGenerator",
  data() {
    return {
      servers: [
        "http://panel.domacitv.com:2095/get.php",

      ],
      selectedServer: "http://panel.domacitv.com:2095/get.php",
      username: "",
      password: "",
    };
  },
  computed: {
    generatedLink() {
      if (!this.username || !this.password) return "";
      return `${this.selectedServer}?username=${this.username}&password=${this.password}&type=m3u_plus&output=mpegts`;
    },
  },
  methods: {
    copyLink() {
      if (this.generatedLink) {
        navigator.clipboard.writeText(this.generatedLink);
        alert("Link je kopiran!");
      }
    },
  },
};
</script>

<style scoped>
.m3u-generator {
  max-width: 900px;
  margin: 0 auto;
  background: #1e1e1e;
  padding: 50px 100px;
  border-radius: 12px;
  color: #fff;
  font-family: Arial, sans-serif;
}
.input-container {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
}
input,
select {
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #444;
  background: #2a2a2a;
  color: #fff;
}
.result {
  margin-top: 20px;
}
button {
  margin-top: 10px;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  background: #3a8ef6;
  color: white;
  cursor: pointer;
}
button:hover {
  background: #3278d8;
}
</style>
